import { Tag, Text } from "@/atoms"
import { Trans } from "@/hooks/useTranslation"

import styles from "./OverviewStepsAdr.module.scss"

import type { DescriptionProps } from "."

export const Description = (props: DescriptionProps) => {
  const { children, tag, tagColor = "error" } = props

  if (tag)
    return (
      <Tag color={tagColor} className={styles.tagStep}>
        <Trans>{tag}</Trans>
      </Tag>
    )

  return (
    <Text type="secondary" className="sm-text-ks">
      <Trans>{children}</Trans>
    </Text>
  )
}
